import commonservice from "@apis/commonservice";
import { atom, useAtom } from "jotai";
import { useRef } from "react";

const customerServiceContactAtom = atom<CustomerServiceContact | null>(null);

export default function useCustomerServiceContact() {
  const [customerServiceContact, setCustomerServiceContact] = useAtom(customerServiceContactAtom);
  const refLoading = useRef(false);

  const requestCustomerServiceContact = async () => {
    try {
      refLoading.current = true;
      const customerServiceContact = await commonservice.fetchCustomerServiceContact();
      setCustomerServiceContact(customerServiceContact);
    } finally {
      refLoading.current = false;
    }
  };

  return { customerServiceContact, requestCustomerServiceContact };
}
